import Icon from './icon.js';

export default Icon;

export const IconFactory = map =>
	map
		.map(type => (Array.isArray(type) ? type : [type]))
		.map(([type, props = {}]) => [type, () => <Icon type={type} {...props} />])
		.reduce((obj, [k, v]) => ({ ...obj, [k]: v }), {});
/*
How to update this file:
    ls -1 | gawk -F. '{print "export const ICON_" gensub(/[- ]/,"_", "g", toupper($1)) " = '"'"'" $1 "'"'"';"}'
*/
export const ICON_24_7_FILLED = '24-7-filled';
export const ICON_APPLE_STAR_EMPTY = 'apple-star-empty';
export const ICON_ARROW_DOWN = 'arrow-down';
export const ICON_ARROW_UP = 'arrow-up';
export const ICON_ARROW_BACK = 'arrow-back';
export const ICON_ARROW_BACKWARDS = 'arrow-backwards';
export const ICON_ATHLETICS = 'athletics';
export const ICON_BALL = 'ball';
export const ICON_BANK_ID = 'bankid';
export const ICON_BASEBALL = 'baseball';

export const ICON_BASKETBALL = 'basketball';
export const ICON_BELL_LINE = 'bell-line';
export const ICON_BET_BUILDER = 'bet-builder';
export const ICON_BETSLIP_LINE = 'betslip-line';
export const ICON_BIATHLON = 'biathlon';
export const ICON_BOTTOM = 'bottom';
export const ICON_BOXING = 'boxing';
export const ICON_BOWLING = 'bowling';
export const ICON_BUBBLES = 'bubbles';
export const ICON_CALENDAR_LINE = 'calendar-line';
export const ICON_CARDS_LINE = 'cards-line';
export const ICON_CHAIR = 'chair';
export const ICON_CHAIR_FILLED = 'chair-filled';
export const ICON_CHAIR_LINE = 'chair-line';
export const ICON_CHAMPAGNE = 'champagne';
export const ICON_CHAT_BUBBLE_LINE = 'chat-bubble-line';
export const ICON_CHECKBOX_SELECTED = 'checkbox-selected';
export const ICON_CHECKBOX_UNSELECTED = 'checkbox-unselected';
export const ICON_CHECKMARK = 'checkmark';
export const ICON_CHERRY = 'cherry';
export const ICON_CHEVRON_UP = 'chevron-up';
export const ICON_CIRCLE_ADD = 'circle-add';
export const ICON_CIRCLE_CHECKMARK = 'circle-checkmark';
export const ICON_CIRCLE_CHECKMARK_FILLED = 'circle-checkmark-filled';
export const ICON_CIRCLE_CLOSE = 'circle-close';
export const ICON_CIRCLE_CLOSED_FILLED = 'circle-closed-filled';
export const ICON_CIRCLE_EMPTY = 'circle-empty';
export const ICON_CIRCLE_EXCLAMATION_FILLED = 'circle-exclamation-filled';
export const ICON_CIRCLE_INFO_FILLED = 'circle-info-filled';
export const ICON_CIRCLE_FILLED = 'circle-filled';
export const ICON_CLOCK_LINE = 'clock-line';
export const ICON_CLOSE = 'close';
export const ICON_CORNER = 'corner';
export const ICON_COIN_LINE = 'coin-line';
export const ICON_COOKE_LINE = 'cookie-line';
export const ICON_COPY_LINE = 'copy-line';
export const ICON_CREDIT_CARD = 'credit-card';
export const ICON_CARD_SINGLE_LINE = 'card-single-line';
export const ICON_LIVE_CASINO = 'live-casino';
export const ICON_CRICKET = 'cricket';
export const ICON_CROWN_LINE = 'crown-line';
export const ICON_CROWN_LINE_VIP = 'crown-line-vip';
export const ICON_CURLING = 'curling';
export const ICON_CYCLING = 'cycling';
export const ICON_DASHBOARD_LINE = 'dashboard-line';
export const ICON_DEALER = 'dealer';
export const ICON_DEPOSIT_LINE = 'deposit-line';
export const ICON_DIAMOND_LINE = 'diamond-line';
export const ICON_DICES = 'dices';
export const ICON_DOCUMENT_CHECKMARK_LINE = 'document-checkmark-line';
export const ICON_DOCUMENT_LINE = 'document-line';
export const ICON_DOCUMENT_SEARCH_LINE = 'document-search-line';
export const ICON_DOWN = 'down';
export const ICON_DOWNLOAD_LINE = 'download-line';
export const ICON_EDIT = 'edit';
export const ICON_EXPLORE = 'explore';
export const ICON_ERASE = 'erase';
export const ICON_EXCLAMATION = 'exclamation';
export const ICON_EXCLUSIVE = 'exclusive';
export const ICON_EYE_HIDDEN = 'eye-hidden';
export const ICON_EYE_VISIBLE = 'eye-visible';
export const ICON_EXTERNAL_LINK = 'external-link';
export const ICON_LINK = 'link';
export const ICON_MINIMIZE_VIEW_LINE = 'minimize-view-line';
export const ICON_MAXIMIZE_VIEW_LINE = 'maximize_view_line';
export const ICON_FACEBOOK = 'facebook';
export const ICON_FEEDBACK = 'feedback';
export const ICON_FENCING = 'fencing';
export const ICON_FILTER_LINE = 'filter-line';
export const ICON_FIRE_LINE = 'fire-line';
export const ICON_FLAG_LINE = 'flag-line';
export const ICON_FOOTBALL = 'football';
export const ICON_HUNDRINGEN = 'hundringen';
export const ICON_FORMULA_1 = 'formula-1';
export const ICON_FOOTBALL_LINE = 'football-line';
export const ICON_GAELIC_FOOTBALL = 'gaelic-football';
export const ICON_GAELIC_HURLING = 'gaelic-hurling';
export const ICON_GIFT_LINE = 'gift-line';
export const ICON_GLOBE_LINE = 'globe-line';
export const ICON_GOLF = 'golf';
export const ICON_GYMNASTICS = 'gymnastics';
export const ICON_HEART = 'heart';
export const ICON_HEART_FILLED = 'heart-filled';
export const ICON_HOME = 'home';
export const ICON_HURLING = 'hurling';
export const ICON_HORSE_RACING = 'horse-racing';

export const ICON_TVBET = 'tvbet';
export const ICON_IMG_PLACEHOLDER = 'img-placeholder';
export const ICON_ICE_HOCKEY = 'ice-hockey';
export const ICON_INBOX_LINE = 'inbox-line';
export const ICON_INFO = 'info';
export const ICON_INSTAGRAM = 'instagram';
export const ICON_LEADERBOARD_POSITION = 'leaderboard-position';
export const ICON_LEFT = 'left';
export const ICON_LINKEDIN = 'linkedin';
export const ICON_LINEUP = 'lineup';
export const ICON_LIVE_LINE = 'live-line';
export const ICON_LIVE_STREAM_LINE = 'live-stream-line';
export const ICON_LOCK_CLOSED_LINE = 'lock-closed-line';
export const ICON_FAVORITE_LINE = 'favorite-line';
export const ICON_LOCK_OPEN_LINE = 'lock-open-line';
export const ICON_LOGOUT_LINE = 'logout-line';
export const ICON_MAIL_CHECKMARK_LINE = 'mail-checkmark-line';
export const ICON_MAIL_LINE = 'mail-line';
export const ICON_MAIL_PENDING_LINE = 'mail-pending-line';
export const ICON_MAINTENANCE = 'maintenance';
export const ICON_MEDAL_STAR_LINE = 'medal-star-line';
export const ICON_MEGAPHONE = 'megaphone';
export const ICON_MENU = 'menu';
export const ICON_MESSENGER = 'messenger';
export const ICON_MINUS_LINE = 'minus-line';
export const ICON_MODERN_PENTHALON = 'modern-penthalon';
export const ICON_MONEY_BAG = 'money-bag';
export const ICON_ONLINE_SPORTS = 'online-sports';
export const ICON_OPEN_BOOK = 'open-book';
export const ICON_OPTIONS_HORIZONTAL = 'options-horizontal';
export const ICON_OPTIONS_VERTICAL = 'options-vertical';
export const ICON_PAPERCLIP_LINE = 'paperclip-line';
export const ICON_PAUSE_ICON = 'pause-icon';
export const ICON_PENDING_LINE = 'pending-line';
export const ICON_PESAPALLO = 'pesapallo';
export const ICON_PHONE_CHECKMARK_LINE = 'phone-checkmark-line';
export const ICON_PHONE_LINE = 'phone-line';
export const ICON_PHONE_PENDING_LINE = 'phone-pending-line';
export const ICON_PIG_LINE = 'pig-line';
export const ICON_PIG_LOSS_LIMITS = 'pig-loss-limits';
export const ICON_PIN = 'pin';
export const ICON_PLANE = 'plane';
export const ICON_PLUS_LINE = 'plus-line';
export const ICON_POLYGON_LINE = 'polygon-line';
export const ICON_PRICE_BOOST = 'price-boost';
export const ICON_PRINTER = 'printer';
export const ICON_PULSE_LINE = 'pulse-line';
export const ICON_QUICK_DEPOSIT_BILLS = 'quick-deposit-dollar-bill';
export const ICON_QUICK_DEPOSIT_LIGHTNING = 'quick-deposit-lightning';
export const ICON_QUICK_DEPOSIT_SMALL_LIGHTNING = 'quick-deposit-small-lightning';
export const ICON_QUICK_DEPOSIT_LIGHTNING_NEW = 'quick-deposit-lightning-new';
export const ICON_QUICK_STATS_ICON = 'quick-stats-icon';
export const ICON_RADIO_SELECTED = 'radio-selected';
export const ICON_RADIO_UNSELECTED = 'radio-unselected';
export const ICON_REFRESH_LINE = 'refresh-line';
export const ICON_RESPONSIBLE_LINE = 'responsible-line';
export const ICON_RIGHT = 'right';
export const ICON_RISK_PROFILE = 'risk-profile';
export const ICON_ROULETTE_WHEEL = 'roulette-wheel';
export const ICON_SEARCH_LINE = 'search-line';
export const ICON_SETTINGS_LINE = 'settings-line';
export const ICON_SENTIMENT_DISSATISFIED = 'sentiment-dissatisfied';
export const ICON_SHARE_LINE = 'share-line';
export const ICON_SHARE_VARIANT = 'share-variant';
export const ICON_SHOOTING = 'shooting';
export const ICON_SHOP_LINE = 'shop-line';
export const ICON_SHOP_PENDING_LINE = 'shop-pending-line';
export const ICON_SIZE_FULLSCREEN_LINE = 'size-fullscreen-line';
export const ICON_SIZE_MINIMIZE_LINE = 'size-minimize-line';
export const ICON_SLOT_JACKPOT = 'slot-jackpot';
export const ICON_SNOWFLAKE = 'snowflake';
export const ICON_CHRISTMAS_TREE = 'christmas-tree';
export const ICON_SLOT_MERKUR = 'slot-merkur';
export const ICON_SLOT_CHERRY = 'slot-cherry';
export const ICON_SLOT_CROWN = 'slot-crown';
export const ICON_SPARKLING = 'sparkling';
export const ICON_SPEAKER_ACTIVE = 'speaker-active';
export const ICON_SPEAKER_MUTE = 'speaker-mute';
export const ICON_SPINNER_LINE = 'spinner-line';
export const ICON_STAR_LINE = 'star-line';
export const ICON_STAR_FILLED = 'star-filled';
export const ICON_STATS = 'stats';
export const ICON_STOP = 'stop';
export const ICON_STOP_LINE = 'stop-line';
export const ICON_STOPWATCH_LINE = 'stopwatch-line';
export const ICON_STREAMS_LINE = 'streams-line';
export const ICON_SUITCASE_LINE = 'suitcase-line';
export const ICON_SUPER_SUB = 'super-sub';
export const ICON_SUPPORT_LINE = 'support-line';
export const ICON_TACHO_METER = 'tacho-meter';
export const ICON_TENNIS = 'tennis';
export const ICON_TELEGRAM = 'telegram';
export const ICON_TROPHY_LINE = 'trophy-line';
export const ICON_TROPHY_STAR_LINE = 'trophy-star-line';
export const ICON_TROPHY_PLAY_LINE = 'trophy-play-line';
export const ICON_THUMBS_DOWN_LINE = 'thumbs-down-line';
export const ICON_THUMBS_UP_LINE = 'thumbs-up-line';
export const ICON_TICKET = 'ticket';
export const ICON_TIER_BRONZE = 'tier-bronze';
export const ICON_TIER_SILVER = 'tier-silver';
export const ICON_TIER_GOLD = 'tier-gold';
export const ICON_TIER_PLATINUM = 'tier-platinum';
export const ICON_TIER_DIAMOND = 'tier-diamond';
export const ICON_TIER_DIAMOND_PLUS = 'tier-diamond-plus';
export const ICON_TOOLS_LINE = 'tools-line';
export const ICON_TOP = 'top';
export const ICON_TRASH_LINE = 'trash-line';
export const ICON_TRASHCAN = 'trashcan';
export const ICON_TSHIRT_LINE = 'tshirt-line';
export const ICON_TWITTER = 'twitter';
export const ICON_UNFOLD_LESS_LINE = 'unfold-less-line';
export const ICON_UNFOLD_MORE_LINE = 'unfold-more-line';
export const ICON_UPLOAD_LINE = 'upload-line';
export const ICON_UEFA_EURO = 'uefa-euro';
export const ICON_USER = 'user';
export const ICON_USER_ADD_LINE = 'user-add-line';
export const ICON_USER_CHECK_LINE = 'user-check-line';
export const ICON_USER_LINE = 'user-line';
export const ICON_USER_LOGIN_LINE = 'user-login-line';
export const ICON_USER_SECRET = 'user-secret';
export const ICON_USER_SETTINGS = 'user-settings';
export const ICON_VERIFIED = 'verified';
export const ICON_WALLET_LINE = 'wallet-line';
export const ICON_WE_SPIN = 'we-spin';
export const ICON_WARNING_LINE = 'warning-line';
export const ICON_WELCOME_SCREEN = 'welcome-screen';
export const ICON_WHISTLEPIPE_LINE = 'whistlepipe-line';
export const ICON_WITHDRAW_LINE = 'withdraw-line';
export const ICON_YOUTUBE = 'youtube';
export const ICON_ALL_SPORTS = 'all-sports';
export const ICON_MY_BETS = 'my-bets';
export const ICON_ROCKET = 'rocket';
export const ICON_EXTERNAL_FILL = 'external-fill';
export const ICON_RUGBY = 'rugby';
export const ICON_PING_PONG = 'ping-pong';
export const ICON_SNOOKER = 'snooker';
export const ICON_HANDBALL = 'handball';
export const ICON_DARTS = 'darts';
export const ICON_ESPORT = 'esport';
export const ICON_WATERPOLO = 'waterpolo';
export const ICON_CHESS = 'chess';
export const ICON_RACING = 'racing';
export const ICON_FLOORBALL = 'floorball';
export const ICON_VOLLEYBALL = 'volleyball';
export const ICON_BADMINTON = 'badminton';
export const ICON_BANDY = 'bandy';
export const ICON_GREYHOUND = 'greyhound';
export const ICON_MMA = 'mma';
export const ICON_SPECIAL = 'special';
export const ICON_TROTTING = 'trotting';
export const ICON_VIDEO_PLAYER = 'video-player';
export const ICON_PLAYING_FIELD = 'playing-field';
export const ICON_TRUSTLY = 'trustly';
export const ICON_TRENDING_UP = 'trending-up';
export const ICON_BETTING = 'betting-limits';
export const ICON_SPENDING_LIMITS = 'spending-limits';
export const ICON_CASINO_SEVEN = 'casino-seven';
export const ICON_ALARM = 'alarm';
export const ICON_ALARM_ADD = 'alarm-add';
export const ICON_ALARM_OFF = 'alarm-off';
export const ICON_ARROW_LEFT = 'arrow-left';
export const ICON_ARROW_RIGHT = 'arrow-right';
export const ICON_BIOMETRICS = 'biometrics';
export const ICON_CHAT_CHECKMARK = 'chat-checkmark';
export const ICON_CHAT_SETTINGS = 'chat-settings';
export const ICON_CIRCLE_ARROW_LEFT = 'circle-arrow-left';
export const ICON_CIRCLE_ARROW_RIGHT = 'circle-arrow-right';
export const ICON_CIRCLE_ARROW_UP = 'circle-arrow-up';
export const ICON_CIRCLE_ARROW_DOWN = 'circle-arrow-down';
export const ICON_CIRCLE_HELP = 'circle-help';
export const ICON_CIRCLE_MINUS = 'circle-minus';
export const ICON_CIRCLE_PROFILE = 'circle-profile';
export const ICON_CIRCLE_OPTIONS = 'circle-options';
export const ICON_CIRCLE_STAR = 'circle-star';
export const ICON_HAJPER_SHOP = 'hajper-shop';
export const ICON_HISTORY = 'history';
export const ICON_MORE = 'more';
export const ICON_KEY = 'key';
export const ICON_PASTE = 'paste';
export const ICON_PHONE_CLOSE = 'phone-close';
export const ICON_PHONE_SETTINGS = 'phone-settings';
export const ICON_REPORT = 'report';
export const ICON_REDEEM_CODE = 'redeem-code';
export const ICON_PASSWORD = 'password';
export const ICON_STOPWATCH_OFF = 'stopwatch-off';
export const ICON_SPEAKER_MINUMUM = 'speaker-minimum';
export const ICON_SPEAKER_MEDIUM = 'speaker-medium';
export const ICON_FAST_FORWARD_FILLED = 'fast-forward-filled';
export const ICON_FAST_FORWARD_LINE = 'fast-forward-line';
export const ICON_STOPWATCH_FILLED = 'stopwatch-filled';
export const ICON_RECORD = 'record';
export const ICON_USER_FILLED = 'user-filled';
export const ICON_VOLATILITY_LOW = 'volatility-low';
export const ICON_VOLATILITY_MID = 'volatility-mid';
export const ICON_VOLATILITY_HIGH = 'volatility-high';
export const ICON_TERMS_AND_CONDITIONS = 'terms-and-conditions';
export const ICON_TUNE = 'tune';
export const ICON_REMAINING = 'remaining';

export const ICON_BOW = 'bow';
export const ICON_DIVING = 'diving';
export const ICON_HOCKEY = 'hockey';
export const ICON_HORSE_JUMPING = 'horse-jumping';
export const ICON_JUDO = 'judo';
export const ICON_KAYAK = 'kayak';
export const ICON_MEDAL = 'medal';
export const ICON_NETBALL = 'netball';
export const ICON_SKIING = 'skiing';
export const ICON_ODDS_BOOST = 'odds-boost';
export const ICON_OLYMPICS = 'olympics';
export const ICON_PENTA = 'penta';
export const ICON_POOL = 'pool';
export const ICON_ROWING = 'rowing';
export const ICON_RUNNING = 'running';
export const ICON_SAILING = 'sailing';
export const ICON_SCOREBOARD = 'scoreboard';
export const ICON_SPEEDWAY = 'speedway';
export const ICON_SQUASH = 'squash';
export const ICON_SURFING = 'surfing';
export const ICON_SWIMMING = 'swimming';
export const ICON_TAEKWONDO = 'taekwondo';
export const ICON_TRIATHLON = 'triathlon';
export const ICON_WEIGHTLIFTING = 'weightlifting';
export const ICON_WINTER = 'winter';
export const ICON_WRESTLING = 'wrestling';
export const ICON_WIDGET = 'widget';
export const ICON_WAVING_HAND = 'waving-hand';
export const ICON_QUICK_DEPOSIT_COINS = 'quick-deposit-coins';
export const ICON_PIN_DISABLED = 'pin-disabled';
export const ICON_SPORTSBOOK = 'sportsbook';
export const ICON_VIRTUALS = 'virtuals';
export const ICON_COLLAPSE_VECTOR = 'collapse-vector';
export const ICON_EXPAND_VECTOR = 'expand-vector';
export const ICON_SPINON_TAG = 'spinon-tag';
export const ICON_BEYONDPLAY = 'beyondplay';
export const ICON_MASTERCARD = 'mastercard';
export const ICON_VISA = 'visa';
export const ICON_PLAY = 'play';
export const ICON_DEFAULT_CARD = 'default-card';
export const ICON_JCB = 'jcb';
export const ICON_VISAELECTRON = 'visaelectron';
export const ICON_MAESTRO = 'maestro';
export const ICON_AMEX = 'amex';
export const ICON_VOLUME_ON = 'volume-on';
export const ICON_VOLUME_OFF = 'volume-off';
export const ICON_FREE_TO_PLAY = 'free-to-play';
export const ICON_ZZZ = 'zzz';
export const ICON_FILTERS_TOGGLE_ICON = 'filters-toggle-icon';
export const ICON_CHEVRON_DOWN_FILLED = 'chevron-down-filled';
export const ICON_PROVIDER_APPARAT = 'provider-apparat';
export const ICON_PROVIDER_BETSOFT = 'provider-betsoft';
export const ICON_PROVIDER_DEFAULT = 'provider-default';
export const ICON_PROVIDER_EVOLUTION = 'provider-evolution';
export const ICON_PROVIDER_EZUGI = 'provider-ezugi';
export const ICON_PROVIDER_FELT_GAMING = 'provider-felt-gaming';
export const ICON_PROVIDER_LIGHT_AND_WONDER = 'provider-light-and-wonder';
export const ICON_PROVIDER_MERKUR = 'provider-merkur';
export const ICON_PROVIDER_MICROGAMING = 'provider-microgaming';
export const ICON_PROVIDER_NO_LIMIT_CITY = 'provider-no-limit-city';
export const ICON_PROVIDER_NOVOMATIC = 'provider-novomatic';
export const ICON_PROVIDER_NYX_GAMING = 'provider-nyx-gaming';
export const ICON_PROVIDER_OCTOPLAY = 'provider-octoplay';
export const ICON_PROVIDER_ORYX = 'provider-oryx';
export const ICON_PROVIDER_PLAYNGO = 'provider-playngo';
export const ICON_PROVIDER_PLAYTECH = 'provider-playtech';
export const ICON_PROVIDER_PRAGMATIC_PLAY = 'provider-pragmatic-play';
export const ICON_PROVIDER_PUSH_GAMING = 'provider-push-gaming';
export const ICON_PROVIDER_QUICKSPIN = 'provider-quickspin';
export const ICON_PROVIDER_RELAX = 'provider-relax';
export const ICON_PROVIDER_SPINON = 'provider-spinon';
export const ICON_PROVIDER_THUNDERKICK = 'provider-thunderkick';
export const ICON_PROVIDER_TVBET = 'provider-tvbet';
export const ICON_PROVIDER_YGGDRASIL = 'provider-yggdrasil';
